import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faQuestion, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useState } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { ButtonTypes } from "../../models/ButtonTypes";
import { Button, ButtonVariant } from "../button/Button";
import { DialogContext } from "./DialogContext";

export interface DialogContent {
    message: string | string[];
    title: string;
    buttons?: DialogButton[]
}

export interface DialogButton {
    id: string,
    text: string,
    onClick: () => void,
    type: ButtonTypes,
    className?: string
}

const buttonTypeToVariant = (type: ButtonTypes): ButtonVariant => {
    switch (type) {
        case ButtonTypes.RedRoundedButton:
        case ButtonTypes.RedButton:
            return 'danger';
        case ButtonTypes.GreenRoundedButton:
        case ButtonTypes.GreenButton:
            return 'submit';
        case ButtonTypes.TextButton:
            return 'outline';
        case ButtonTypes.BlueRoundedButton:
        case ButtonTypes.BlueButton:
        default:
            return 'primary';
    }
};

const Dialog: FC = ({ children }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [dialogContent, setDialogContent] = useState<DialogContent>({
        message: '',
        title: '',
        buttons: []
    });
    const [isArrayMessage, setIsArrayMessage] = useState<boolean>(false);
    const { translate } = useLocale();

    const pushError = (dialogContent: DialogContent) => {
        setOpen(true);
        setDialogContent(dialogContent);
        setIsArrayMessage(Array.isArray(dialogContent.message) && dialogContent.message.length > 1);
    }

    const pushInfo = (dialogContent: DialogContent) => {
        setOpen(true);
        setDialogContent(dialogContent);
        setIsArrayMessage(Array.isArray(dialogContent.message) && dialogContent.message.length > 1);
    }

    const onButtonClicked = (onCliked: () => void) => {
        onCliked();
        setOpen(false);
    }

    return <DialogContext.Provider value={{ pushError, pushInfo }}>
        <Modal
            isOpen={open}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-dialog fixed top-0 left-0 h-screen bg-opacity-50 bg-black z-50"
            className="bg-white border-none m-auto shadow select-none outline-none  rounded-md">
            <div className="py-3 px-4 flex flex-col" style={{ width: '400px', ...( isArrayMessage ? {height:'225px'} : {}) }} >
                <div className="text-lg font-bold px-3 flex-shrink-0">{dialogContent.title}</div>
                { isArrayMessage ?
                    <div className="flex flex-col overflow-y-auto flex-1 min-h-0 mb-3">
                        {dialogContent.message && dialogContent.message.length > 0 && Array(dialogContent.message).map((message, index) => {
                            return <p key={index} className="flex text-black break-normal text-base mb-3 px-3 py-2 " id={`dialogueMessage_${index}`}>
                                {message}
                            </p>
                        })}
                    </div>
                    :
                    <p className="flex text-black break-normal text-base mb-3 px-3 py-2" id='dialogueMessage'>
                    {dialogContent.message}
                    </p>
                }

                <div className="flex flex-row-reverse gap-2">
                    {dialogContent.buttons && dialogContent.buttons.length > 0 ?
                        dialogContent.buttons?.map((button) => {
                            return <Button
                                id={button.id}
                                key={button.id}
                                variant={buttonTypeToVariant(button.type)}
                                onClick={() => onButtonClicked(button.onClick)}
                                className={button.className}
                            >
                                {button.text}
                            </Button>
                        }) :
                        <Button variant="primary" onClick={() => setOpen(false)} id='dialogueOkBtn'>
                            {translate.byKey(TranslationKeys.ok)}
                        </Button>}
                </div>
            </div>
        </Modal>
        {children}
    </DialogContext.Provider>
}

export default Dialog;
